import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';
import './styles/global.css';
import { installErrorReporting } from './services/errorReport';
import { Splash } from './components/Splash';
// Importing this early installs the `beforeinstallprompt` listener before Chrome fires it.
import './services/installPrompt';

installErrorReporting();

// Register the service worker on the WEB build only (never inside the native
// Capacitor app, which serves from its own WebView origin). This is what makes the
// web app installable on Android — Chrome only offers the one-tap "add to home
// screen" once a service worker controls the page. See public/sw.js.
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* best-effort: a failed SW registration must never break the app */
    });
  });
}

// The redesign is NOT a separate root: the new arrival-first Today is rendered
// inside the real Shell (App.tsx) when VITE_NEW_UI=true (NEW_UI). The flag only
// swaps the Today tab's content; every other screen, gate, provider and overlay
// is the live app, unchanged. Production leaves NEW_UI unset → current app.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Splash />
  </React.StrictMode>,
);
